// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2o9Rx","col":"styles_col__9WGjY"};